// extracted by mini-css-extract-plugin
module.exports = {"eyebrow":"Eyebrow_eyebrow__ivVP5","onDark":"Eyebrow_onDark__gpLi8"};